import { Strategy } from 'utility-ts-strategy';

interface IPendingCourseFieldSizes {
  outerDivSize: number;
  labelMedSize: number;
  innerDivMedSize: number;
  inputSize: number;
}

export interface IPendingCourseFormTileSizeStrategy {
  subjectNumberCredits: IPendingCourseFieldSizes;
  name: IPendingCourseFieldSizes;
}

angular.module('capability-ng-checklist').constant(
  'ngPendingCourseAdditionalInfoStrategy',
  new Strategy<IPendingCourseFormTileSizeStrategy>({
    enable: {
      subjectNumberCredits: {
        outerDivSize: 3,
        labelMedSize: 12,
        innerDivMedSize: 12,
        inputSize: 11
      },
      name: {
        outerDivSize: 6,
        labelMedSize: 12,
        innerDivMedSize: 12,
        inputSize: 12
      }
    },
    disable: {
      subjectNumberCredits: {
        outerDivSize: 12,
        labelMedSize: 2,
        innerDivMedSize: 10,
        inputSize: 12
      },
      name: {
        outerDivSize: 12,
        labelMedSize: 2,
        innerDivMedSize: 10,
        inputSize: 12
      }
    }
  })
);



// WEBPACK FOOTER //
// ./app/lib/transfer/strategies/pending_course_additional_info_strategy.ts